@if (!userService.isLoggedin) {
  <div class="single_page_wrapper d-flex flex-column">
    <div class="logo_header text-center p-2">
      <a href="/" title="Family Central logo"><img src="/assets/images/familycentral-logo.svg" width="155" height="87" alt="Family Central" /></a>
    </div>
    <div class="single_page_body d-flex justify-content-center align-items-center flex-grow-1">
      <div class="single_page_content">
        <form id="msform" method="post" name="registration">
          @if (familyInviationService?.FcInvitationDetails?.status!=1 || familyInviationService?.FcInvitationDetails?.Isdeleted !=null  ) {
            <div class="card_header">
              <h2 class="h2 text-center">Welcome to Family Central</h2>
              <p class="invitefamily_content" style="text-align: left;">
                Your Trusted Professional <span class="text-capitalize">{{familyInviationService?.FcInvitationDetails?.senderName}}</span> would like you to experience Family Central free of cost for 14 days. Below are the steps of how you can experience it.<br>
                1. Please click on the button below to accept the Invite from your Trusted Professional Advisor.<br>
                2. For the sign-up you will need a valid email address and an active phone number. You will need this to ensure that your information is kept private to with you.<br>
                3. Once you accept and complete on boarding process, your Trusted Professional will be notified that you are ready to receive documents or information from them in a secure manner.<br>
                4. Once your Trusted Professional sends you the documents they can be viewed in your secure personal vault. Select your Personal Vault to view the documents.<br>
                5. In the Personal vault you will find a folder name consisting of two parts, a. Type of Trusted Professional and b. First name of the Trusted Professional. This is where your Trusted Professional is sharing information or documents with you.<br>
                6. At any point if you need further assistance please reach out to Customer Care by calling <a href="tel:1-888-780-3264">1-888-780-3264</a>
              </p>
            </div>
            <div class="form-group submit_btn text-center mt-3">
              <button class="primary_btn"(click)="isNewUser ? navigateToQuestionnaires() : AccceptInvitePopup()" [disabled]="isBtnDisable" >Accept Invite</button>
            </div>
          }
          @if (familyInviationService?.FcInvitationDetails?.status==1) {
            <div>
              <div class="text-center mb-4">
                <h2 class="h2">Link Expired</h2>
              </div>
            </div>
          }
        </form>
      </div>
    </div>
  </div>
}

<ng-template #AcceptInvite>
  <div class="modal-dialog modal-dialog-centered m-0">
    <div class="modal-content">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onClose()"></button>
      <div class="content text-center">
        <h3 class="h3 px-5 py-5">Invitation Accepted successfully.</h3>
        <button (click)="onClose()" class="primary_btn">Proceed to Login</button>

      </div>
    </div>
  </div>
</ng-template>